/**
 * @generated SignedSource<<52cba28760f97e71361ae273d4179210>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type SwitchAccountInput = {
  clientMutationId?: string | null;
  refreshToken: string;
  targetAccount: string;
};
export type accountSwitcher_SwitchAccountMutation$variables = {
  input: SwitchAccountInput;
};
export type accountSwitcher_SwitchAccountMutation$data = {
  readonly Auth: {
    readonly switchAccount: {
      readonly clientMutationId: string | null;
      readonly jwtTokens: {
        readonly accessToken: string;
        readonly refreshToken: string;
      };
    } | null;
  };
};
export type accountSwitcher_SwitchAccountMutation = {
  response: accountSwitcher_SwitchAccountMutation$data;
  variables: accountSwitcher_SwitchAccountMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "AuthMutations",
    "kind": "LinkedField",
    "name": "Auth",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
          }
        ],
        "concreteType": "SwitchAccountPayload",
        "kind": "LinkedField",
        "name": "switchAccount",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "JwtLoginInformation",
            "kind": "LinkedField",
            "name": "jwtTokens",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "accessToken",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "refreshToken",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "clientMutationId",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "accountSwitcher_SwitchAccountMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "accountSwitcher_SwitchAccountMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "b6c6d4af1aebb547cd6956c527e52d46",
    "id": null,
    "metadata": {},
    "name": "accountSwitcher_SwitchAccountMutation",
    "operationKind": "mutation",
    "text": "mutation accountSwitcher_SwitchAccountMutation(\n  $input: SwitchAccountInput!\n) {\n  Auth {\n    switchAccount(input: $input) {\n      jwtTokens {\n        accessToken\n        refreshToken\n      }\n      clientMutationId\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "51042da924c9cbafcbfd0101cb2dc493";

export default node;
